<template>
  <v-card-text class="inserted-values px-9 pt-3">
    <v-row>
      <v-col cols="3" class="request-label">
        Datum od
      </v-col>

      <v-col cols="9" class="request-value">
        {{ dateFormattingHours(createdAt) || missingValueString }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Požadovaný termín obnovení
      </v-col>

      <v-col cols="9" class="request-value">
        {{
          dateFormattingHours(individualDistributionRenewal.requestedRenewalDate)
          || missingValueString
        }}
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>

export default {
  name: 'IndividualDistributionRenewalInsertedValues',
  props: {
    individualDistributionRenewal: {
      type: Object,
      required: false,
    },
    createdAt: {
      type: String,
      required: false,
    },
  },
};
</script>
